/** 
 * Type definition for Lime user personal info
 */
export interface PersonalInfo {
    username?: string;
    email?: string;
    first_name?: string;
    last_name?: string;
    phone_number?: string;
    social_security?: string;
    is_jointfiling?: boolean;
}

export const defaultPersonalInfo: PersonalInfo = {
    username: "",
    email: "",
    first_name: "",
    last_name: "",
    phone_number: "",
    social_security: "",
    is_jointfiling: false
}

export const fallbackPhoneNumber: string = '9999999999';
